(function () {
  if (!window.location.pathname.includes('springfield-pridefest-2026') &&
      !window.location.search.includes('hatlab=1')) return;

  var EVENT_DATE = new Date('May 16, 2026 09:00:00').getTime();

  function getTimeLeft() {
    var now = new Date().getTime();
    var diff = EVENT_DATE - now;
    if (diff <= 0) return null;
    return {
      days:    Math.floor(diff / (1000 * 60 * 60 * 24)),
      hours:   Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
      minutes: Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)),
      seconds: Math.floor((diff % (1000 * 60)) / 1000)
    };
  }

  function buildBar() {
    if (!window.location.pathname.includes('springfield-pridefest-2026')) return null;
    var bar = document.createElement('div');
    bar.id = 'bnb-pride-countdown';
    bar.style.cssText = [
      'background: linear-gradient(90deg,#e40303,#ff8c00,#ffed00,#008026,#004dff,#750787)',
      'color: #fff',
      'text-align: center',
      'padding: 10px 16px',
      'font-size: 15px',
      'font-weight: 600',
      'letter-spacing: 0.03em',
      'text-shadow: 0 1px 3px rgba(0,0,0,0.4)',
      'position: relative',
      'z-index: 10'
    ].join(';');
    document.body.insertAdjacentElement('afterbegin', bar);
    return bar;
  }

  function update(bar) {
    if (!bar) return;
    var t = getTimeLeft();
    if (!t) {
      bar.textContent = '🏳️‍🌈 Springfield PrideFest 2026 is TODAY! See you there!';
      return;
    }
    bar.textContent = '🏳️‍🌈 Springfield PrideFest 2026 — '
      + t.days + 'd ' + t.hours + 'h ' + t.minutes + 'm ' + t.seconds + 's away!';
  }

  function buildBackButton() {
    var btn = document.createElement('a');
    btn.href = '/pages/springfield-pridefest-2026';
    btn.id = 'bnb-back-to-start';
    btn.textContent = '🏳️‍🌈 Start Over';
    btn.style.cssText = [
      'position: fixed',
      'bottom: 24px',
      'left: 24px',
      'z-index: 9999',
      'background: linear-gradient(90deg,#e40303,#ff8c00,#ffed00,#008026,#004dff,#750787)',
      'color: #fff',
      'font-weight: 700',
      'font-size: 14px',
      'padding: 10px 18px',
      'border-radius: 30px',
      'text-decoration: none',
      'box-shadow: 0 4px 12px rgba(0,0,0,0.25)',
      'text-shadow: 0 1px 2px rgba(0,0,0,0.3)',
      'display: block'
    ].join(';');
    btn.addEventListener('mouseover', function() { this.style.opacity = '0.85'; });
    btn.addEventListener('mouseout', function() { this.style.opacity = '1'; });
    document.body.appendChild(btn);
  }

  function styleHatlabBackButton() {
    var btn = document.querySelector('a.hatlab-back-button');
    if (btn) {
      btn.style.background = 'linear-gradient(90deg,#e40303,#ff8c00,#ffed00,#008026,#004dff,#750787)';
      btn.style.color = '#fff';
      btn.style.border = 'none';
      btn.style.borderRadius = '30px';
      btn.style.fontWeight = '700';
      btn.style.textShadow = '0 1px 2px rgba(0,0,0,0.3)';
      btn.style.padding = '10px 24px';
      // Fix href — point back to Pride page instead of main lid-locker
      var currentHref = btn.getAttribute('href') || '';
      btn.setAttribute('href', currentHref.replace('/pages/lid-locker', '/pages/springfield-pridefest-2026'));
    } else {
      setTimeout(styleHatlabBackButton, 500);
    }
  }

  function init() {
    var bar = buildBar();
    if (bar) {
      update(bar);
      setInterval(function () { update(bar); }, 1000);
    }
    buildBackButton();
    styleHatlabBackButton();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();